export default {
  'conversation.deactivatedUserGuard.highlight': 'Note',
  'conversation.deactivatedUserGuard.message':
    'This is a deactivated account. You can only view the archived messages.',
};
